import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { activateLoader } from "../store/Actions/utils";

const Pagos = () => {
  const dispatch = useDispatch();
  const [nombre, setnombre] = useState("");
  const [url, seturl] = useState("");
  const [alto, setalto] = useState("");
  const [ancho, setancho] = useState("");
  const iframeRef = useRef(null);
  const [loading, setloading] = useState(false);

  const activateLoading = (state) => dispatch(activateLoader(state));
  const userInfo = useSelector((state) => state.App.userInfo);
  const isAuth = useSelector((state) => state.App.isAuth);

  useEffect(() => {
    const getListSharePoint = async (servicename, param) => {
      const header = {
        "Content-Type": "application/json",
        Accept: "application/json; odata=verbose",
      };
      const data = await fetch(
        `${document.location.origin}/salud/proveedores/_api/web/lists/getbytitle('${servicename}')/items?$filter=(nombre eq '${param}')`,
        {
          method: "GET",
          headers: header,
        }
      );

      const response = await data.json();

      const { d: { results = null } = {} } = response;

      if (results !== undefined || results !== null) {
        seturl(results[0].url);
        setalto(results[0].alto);
        setancho(results[0].ancho);
        setnombre(results[0].nombre);
      }
    };
    const url = window.location.href;
    let queryParamCod = null;
    if (url.toLowerCase().includes("consulta")) {
      queryParamCod = "consulta";
    }

    if (url.toLowerCase().includes("radicacion")) {
      queryParamCod = "radicacion";
    }

    if (queryParamCod !== null && queryParamCod !== "") {
      getListSharePoint("administracionIframes", queryParamCod);
    }
  }, []);
  useEffect(() => {
    if (
      iframeRef.current !== null &&
      iframeRef.current !== undefined &&
      url !== "" &&
      loading &&
      userInfo !== null &&
      userInfo !== undefined
    ) {
      let idIframe = iframeRef.current.contentWindow;
      let params;
      params = {
        tipo_docu_identidad: userInfo.TipoIdentificacion,
        no_documento: userInfo.LegalID,
      };
      if (
        (userInfo.TipoIdentificacion !== undefined ||
          userInfo.LegalID !== undefined ||
          userInfo.TipoIdentificacion !== null ||
          userInfo.LegalID !== null) &&
        idIframe !== null &&
        idIframe !== undefined &&
        isAuth
      ) {
        //Envia los datos al iframe, validar que el iframe ya este cargado antes de enviar los datos
        idIframe.postMessage(params, url);
      }
    }
  }, [url, loading]);
  const changeLoad = () => {
    setloading(true);
    activateLoading(false);
  };

  return (
    <>
      {url !== "" && url !== null && (
        <>
          {nombre.toLowerCase().includes("consulta") && loading && (
            <div className="consulta__message">
              <h2>
                {
                  // eslint-disable-next-line no-undef
                  i18next.t("consulta.titulo")
                }
              </h2>
              <p>
                {
                  // eslint-disable-next-line no-undef
                  i18next.t("consulta.mensaje1")
                }
                <a
                  className="consulta__link"
                  // eslint-disable-next-line no-undef
                  href={i18next.t("consulta.descargaLink")}
                >
                  {
                    // eslint-disable-next-line no-undef
                    i18next.t("consulta.linkMensaje")
                  }
                </a>
                {
                  // eslint-disable-next-line no-undef
                  i18next.t("consulta.mensaje2")
                }
              </p>
            </div>
          )}
          <iframe
            className={`${loading ? "iframe_content" : "ocultar"}`}
            ref={iframeRef}
            id={nombre}
            title={nombre}
            //width={ancho}
            height={alto}
            src={url}
            onLoad={changeLoad}
          />
        </>
      )}
    </>
  );
};

export default Pagos;
